import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function SocialStudies({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-3 -1 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M24.8821333 1.33293333c1.602.81666667 3.1053334 1.89533334 4.4453334 3.236 6.8626666 6.86199997 6.8626666 17.98933337 0 24.85199997-6.862 6.8626667-17.9886667 6.8626667-24.85200003 0-1.26-1.26-2.288-2.664-3.086-4.158M9.3714 37.734h15.0606667" />
        <path d="M2.9092 17.0373333C2.97653333 9.37533333 9.24253333 3.218 16.9052 3.28533333c7.6626667.068 13.8193333 6.334 13.752 13.99599997-.0673333 7.6626667-6.334 13.82-13.996 13.752-7.66266667-.0666666-13.81933333-6.3333333-13.752-13.996zM17.2754 37.734V34.94" />
      </g>
    </svg>
  )
}

SocialStudies.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
